<template>
  <div>
    
  </div>
</template>

<script>
import PlayerList from '@/components/PlayerList.vue';

export default {

  computed: {
    gameSettings: {
      get() {
        return this.$store.state.lobby.gameSettings;
      },
      set(data) {
        this.$store.commit('setGameSettings', data);
      },
    },
    lobbyPlayers: {
      get() {
        return this.$store.state.lobby.players;
      },
      set(data) {
        this.$store.commit('setPlayers', data);
      },
    },
  },

  components: {
    PlayerList,
  },
}
</script>

<style lang="scss" scoped>
  
</style>